module.exports = __webpack_public_path__ + "static/images/test-img.e57b991.png";